import { useMediaQuery, useTheme } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from 'utils/constants/responsive';

/**
 * Return true if screen is mobile size
 * @returns {boolean}
 */
export default function useMobile() {
  return useMediaQuery(useTheme().breakpoints.down(MOBILE_BREAKPOINT));
}